import React, { useEffect, useState } from "react";
import { fetchNextFunFact } from "../../../utils/funFacts";

interface Props {
  funFact: string;
  showFunFactModal: boolean;
  handleHideFunFactModal: () => void;
}

const FunfactModal: React.FC<Props> = ({
  funFact,
  showFunFactModal,
  handleHideFunFactModal,
}) => {
  const [fact, setFunFact] = useState(funFact);
  const [loadingFact, setLoadingFact] = useState(false);

  useEffect(() => {
    setFunFact(funFact);
  }, [funFact]);

  useEffect(() => {
    if (!showFunFactModal) return;

    document.body.style.overflow = "hidden";

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        handleHideFunFactModal();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = "";
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleHideFunFactModal, showFunFactModal]);

  const getFunFact = () => {
    setLoadingFact(true);

    fetchNextFunFact(fact)
      .then((nextFact) => {
        setFunFact(nextFact);
        setLoadingFact(false);
      })
      .catch(() => {
        setLoadingFact(false);
      });
  };

  return (
    <div
      className={`fact-backdrop ${showFunFactModal ? "is-open" : ""}`}
      role="dialog"
      aria-modal="true"
      aria-labelledby="factEyebrow"
      aria-hidden={!showFunFactModal}
      onClick={(event) => {
        if (event.target === event.currentTarget) {
          handleHideFunFactModal();
        }
      }}
    >
      <div className="fact-modal">
        <button
          className="fact-close"
          type="button"
          aria-label="Close"
          onClick={handleHideFunFactModal}
        >
          <svg aria-hidden="true">
            <use href="#icon-close" />
          </svg>
        </button>
        <div className="fact-ic">
          <svg aria-hidden="true">
            <use href="#ln-bulb" />
          </svg>
        </div>
        <h2 className="fact-title" id="factEyebrow">
          Did you know?
        </h2>
        <div className="fact-body">{fact || "Loading a fact."}</div>
        <div className="fact-foot">
          <button
            type="button"
            className="btn btn-primary btn--sm"
            disabled={loadingFact}
            onClick={getFunFact}
          >
            {loadingFact ? "Loading..." : "Another fact"}
          </button>
          <button
            type="button"
            className="btn btn-ghost btn--sm"
            onClick={handleHideFunFactModal}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default FunfactModal;
